import * as amplify from "../util/amplify.ts";
import * as FwDatas from "../FwDatas.ts";
import * as libLocation from "../lib/location.ts";
import * as INR from "../INR.ts";
import * as websocket from "../util/websocket.ts";
import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import {PlaceCache, PositionCache} from "../server/objects/MapBeans.ts";
import * as i18n from "../i18n.ts";
import {initPaneRight} from "../util/PaneRight.ts"
import TPLmapPlaces from "../map/map_places.mustache";
import Icons from "../svg/Icons.ts";

  var
    // Private field
    map: any,
    positionById: any,
    currentModal: modal.DomModal = null,
    lastRefreshByFamily: Record<string, Date> = {};


  //TODO maybe put this globally
  websocket.subscribe(["GeolocPositionRefreshError"],function(msg: any){
    modal.alert(msg.push.message);
  });

  function editPlace(place?: any): void {
    import("../map/place_edit.mustache").then(function(TPL){
      modal.closeDomModal()
      currentModal = modal.openDomModal(TPL,place);
    });

  }
  function viewPlace(place: any): void {
    import("../map/place_view.mustache").then(function(TPL){
      currentModal = modal.openDomModal(TPL,place);
    });

  }
  function mapcheckin(): void {
    import("../map/modal_checkin.mustache").then(function(TPL){
      currentModal = modal.openDomModal(TPL,{});
    });

  }
  function closeModal(): void {
    if(currentModal!==null){
      modal.closeDomModal(currentModal);
      currentModal=null;
    }
  }

  function modalError(error: any): void {
    if(currentModal!==null){
      //FIXME i18n this
      modal.alert("Cannot localize place");
    }
  }
  function onSuccess(place: any): void {
    closeModal();
    PlaceCache.invalidate();
    amplify.publish("modified",["place"]);
    refresh()
    map.centerPlace(place);
    //libLocation.goTo("map.php?placeId="+place.metaId);
  }
  ApiServer['custom.poiupdate'] = ApiServer.poiupdate.prepare(onSuccess,modalError)
  ApiServer['custom.poicreate'] = ApiServer.poicreate.prepare(onSuccess,modalError)

  function showUserDetailsOverlay(location: any): void {
    if(location.accountId){
      import("../map/location_view.mustache").then(function(TPL){
        if(location.address && !location.address.formattedAddress){
          ApiServer.georeverse(location.address.latitudeE6,location.address.longitudeE6,function(geoAddress: any){
            //copy only data we do not have
            location.address.attribute0Country = geoAddress.attribute0Country;
            location.address.attribute1State = geoAddress.attribute1State;
            location.address.attribute2Town = geoAddress.attribute2Town;
            location.address.attribute3ZipCode = geoAddress.attribute3ZipCode;
            location.address.attribute4Line = geoAddress.attribute4Line;
            location.address.formattedAddress = geoAddress.formattedAddress;

            modal.openDomModal(TPL,location)
          });
        }else{
          modal.openDomModal(TPL,location)
        }
      });
    }
  }

  async function refresh(): Promise<void> {
    //FIXME turn all that to promise
    var [places,newPositionById] = await Promise.all([PlaceCache.refresh(),PositionCache.refresh()]);
    positionById = newPositionById;
    updateFamilybarIcon(positionById);
    map.refresh(positionById,places.filter((place: any)=>!place.isTemporary));
    majPlaceList(places)
  }

  function updateFamilybarIcon(positionById: any): void {
    Object.entries(positionById).forEach(([key, obj]: [string, any]) => {
      const node = document.querySelector(`i[data-fw-menuicon-for='${obj.accountId}']`) as HTMLElement;
      if (!node) return;

      if(obj.geolocSharing==='NEVER'){
        node.innerHTML = Icons.ic_never.toString();
      }else if(obj.geolocSharing==='PLACES'){
        node.innerHTML = Icons.ic_places.toString();
      }
    });
  }

  function majPlaceList(placesWithTemporaries: any[]): any[] {
    var
      places = placesWithTemporaries.filter((place: any)=>!place.isTemporary);
    const mapPlacesNode = document.getElementById("map-places");
    if (mapPlacesNode) {
      Html.setHtml(mapPlacesNode, TPLmapPlaces, {empty:places.length===0,places});
    }
    return places;
  }

  async function loadMap (google_map: any): Promise<void> {
    var refreshDate = lastRefreshByFamily[FwDatas.getFamily().metaId];
    if(refreshDate==null || ((new Date()).getTime()-refreshDate.getTime())>600000){ //more than 10 minutes
      lastRefreshByFamily[FwDatas.getFamily().metaId] = new Date();
      ApiServer.locrequestpositionrefresh();
    }
    var
      [placesWithTemporaries,newPositionById] = await Promise.all([PlaceCache.need(),PositionCache.need()]),
      params = libLocation.getURLParams(),
      places = majPlaceList(placesWithTemporaries);
    positionById = newPositionById;



    map = google_map.createMap(positionById,places);


    if(params.accountId){
      amplify.publish ("familyMemberSelected", {
        selected:  params.accountId
      });
    }else if(params.placeId){
      amplify.publish ("placeSelected", params.placeId);
    }else if(params.lat){
      map.centerAddress({latitude: parseInt(params.lat,10)/1E6,longitude: parseInt(params.lng,10)/1E6});
    }
  }

  INR.onPage(INR.URL.MAP,function(){

    initPaneRight()


    import("./googleApi.ts").then(function(googleApi){
      googleApi.loadThen(function(){
        import("./google_map.ts").then((googleMap: any)=>{
          loadMap(googleMap);
          PositionCache.need().then((positionById: any)=>{
            updateFamilybarIcon(positionById);
            Object.entries(positionById).forEach(([key, obj]: [string, any]) => {
              if(obj.panicButtonActivated){
                import('../modal/snack_simple.mustache').then((TPL: any)=>{
                  const snackResult = modal.snack(TPL,{
                    color:"var(--red)",
                    icon:"notification_important",
                    title:i18n.get("map.panicButtonActivated",FwDatas.getProfile(obj.accountId).firstName)
                  },5000);
                  snackResult.node.addEventListener('click', () => {
                    Html.triggerbystring(null,"selectmember|"+obj.accountId);
                  });
                })
              }
            });
          });

        })
      });
    });
    INR.subscribe("handleParam",function(){
      import("./google_map.ts").then(loadMap)
    });
    INR.subscribe ("pageUnload", function(){
      map.destroy();
    });
    INR.subscribe ("placeDeleted", function(){
      libLocation.goTo('map.php')
    });
    INR.subscribe ("familyMemberSelected", async function(event: any){
      await refresh();
      var position = positionById[event.selected];
      if(event.selected==="all"){
        map.centerFamilyMember(null,true);
      }else if(position){
        map.centerFamilyMember(position,true);
      }
      if(event.fromFamilybar===true){
        return;
      }
      if(event.selected===FwDatas.getAccountId() && (!position || !position.address)){
        mapcheckin()
      }else{
        showUserDetailsOverlay(position||new ApiServer.types.ILocation({accountId:event.selected}));
        if(event.fromFamilybar){
          const autotrackBtn = document.querySelector(`*[data-fw-onclick="requestautotrack|${event.selected}"]`) as HTMLElement;
          if (autotrackBtn) {
            autotrackBtn.click();
          }
        }
      }


    });
    INR.subscribe ("placeSelected", function (placeId: string) {
      var place = FwDatas.get(placeId);
      map.centerPlace(place);
      viewPlace(place);
    });


  });
  Html.registerDom({
    checkin(): void {
      var placeId = Html.getDomMetaId(this);
      ApiServer.locpublishplacelocation(null,placeId,"IN",refresh);
    },
    maprefresh(): void {
      refresh().then(function(){
        const userOverlay = document.querySelector("[data-fw-location-accountid]") as HTMLElement;
        if(userOverlay){
          const accountId = userOverlay.getAttribute("data-fw-location-accountid");
          const position = accountId ? positionById[accountId] : null;
          if (accountId) {
            showUserDetailsOverlay(position||new ApiServer.types.ILocation({accountId:accountId}));
          }
        }

      });
    },
    addplace(): void {
      editPlace();
    },

    editplace(): void {
      var
        node = Html.getDomMetaIdNode(this),
        id = Html.getDomMetaId(node);
      editPlace (FwDatas.get(id));
    },
    mapcheckin,
    mapzoommore(): void {
      map.addZoom(1)
    },
    mapzoomless(): void {
      map.addZoom(-1)
    },
    async placedelete(): Promise<void> {
      if(!await modal.confirmDelete("mapLayout.deletePlaceConfirm")) return;

      ApiServer.metadelete(Html.getDomMetaId(this));
      PlaceCache.invalidate();
      modal.closeDomModal()
      amplify.publish('placeDeleted')

    }

  });

  amplify.subscribe("mapcheckindone",function(){
    modal.closeDomModal();
    modal.toast({text:'map.checkin.done',button:[{title:"map.checkin.seepost",onclick:function(){libLocation.goTo('home.php')}}]})
    refresh()

  })
